import { __decorate, __param, __awaiter } from 'tslib';
import { CommonModule } from '@angular/common';
import { HostBinding, Input, Component, NgModule, Inject, ɵɵdefineInjectable, ɵɵinject, Injectable, EventEmitter, Output, forwardRef, ChangeDetectorRef, Directive, NgZone, ViewChild } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule, NgControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import player from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef, MatSnackBarConfig, MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/bottom-sheet';
import * as ɵngcc3 from '@angular/material/dialog';
import * as ɵngcc4 from '@angular/cdk/layout';
import * as ɵngcc5 from 'ngx-lottie';
import * as ɵngcc6 from '@angular/material/form-field';
import * as ɵngcc7 from '@angular/material/input';
import * as ɵngcc8 from '@angular/forms';
import * as ɵngcc9 from '@angular/material/autocomplete';
import * as ɵngcc10 from '@angular/material/select';
import * as ɵngcc11 from '@angular/material/core';
import * as ɵngcc12 from '@angular/material/checkbox';
import * as ɵngcc13 from '@angular/material/radio';
import * as ɵngcc14 from '@angular/material/snack-bar';
import * as ɵngcc15 from '@angular/material/tooltip';
import * as ɵngcc16 from '@angular/cdk/text-field';

function IconComponent_img_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r0.asset, ɵngcc0.ɵɵsanitizeUrl);
} }
function ButtonComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelement(1, "span");
    ɵngcc0.ɵɵelement(2, "span");
    ɵngcc0.ɵɵelement(3, "span");
    ɵngcc0.ɵɵelementEnd();
} }
function ButtonComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("post-loading", ctx_r1.loadingFinished);
} }
const _c0 = function (a0) { return [a0]; };
const _c1 = ["*"];
function WebModalMobileComponent_zip_button_0_zip_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "zip-icon", 8);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("type", ctx_r3.data.iconType);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r3.data.icon);
} }
function WebModalMobileComponent_zip_button_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "zip-button", 6);
    ɵngcc0.ɵɵtemplate(1, WebModalMobileComponent_zip_button_0_zip_icon_1_Template, 1, 2, "zip-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.data.icon);
} }
function WebModalMobileComponent_zip_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "zip-button", 9);
    ɵngcc0.ɵɵlistener("click", function WebModalMobileComponent_zip_button_5_Template_zip_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.close(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.data.actionLeft, " ");
} }
function WebModalMobileComponent_zip_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "zip-button", 10);
    ɵngcc0.ɵɵlistener("click", function WebModalMobileComponent_zip_button_6_Template_zip_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.confirm(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.data.actionRight, " ");
} }
function WebModalComponent_zip_button_0_zip_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "zip-icon", 8);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("type", ctx_r3.data.iconType);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r3.data.icon);
} }
function WebModalComponent_zip_button_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "zip-button", 6);
    ɵngcc0.ɵɵtemplate(1, WebModalComponent_zip_button_0_zip_icon_1_Template, 1, 2, "zip-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.data.icon);
} }
function WebModalComponent_zip_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "zip-button", 9);
    ɵngcc0.ɵɵlistener("click", function WebModalComponent_zip_button_5_Template_zip_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.close(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.data.actionLeft, " ");
} }
function WebModalComponent_zip_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "zip-button", 10);
    ɵngcc0.ɵɵlistener("click", function WebModalComponent_zip_button_6_Template_zip_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.confirm(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.data.actionRight, " ");
} }
const _c2 = function (a0) { return { center: a0 }; };
function ProgressBarComponent_img_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.imageUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function ProgressBarComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
} if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", i_r4 <= ctx_r1.currentStep);
} }
function ProgressBarComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r2.message, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.message);
} }
function WebInputComponent_mat_error_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-error", 3);
    ɵngcc0.ɵɵlistener("click", function WebInputComponent_mat_error_6_Template_mat_error_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.errorClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("innerHTML", ctx_r0.error, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.error);
} }
function WebInputComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.prefix);
} }
function WebInputComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵelement(1, "zip-icon", 9);
    ɵngcc0.ɵɵelementEnd();
} }
function InputComponent_mat_error_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-error", 4);
    ɵngcc0.ɵɵlistener("click", function InputComponent_mat_error_6_Template_mat_error_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.linkClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("innerHTML", ctx_r0.error, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.error);
} }
function InputComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵelement(1, "zip-icon", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r1.icon);
} }
function InputComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵelement(1, "zip-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} }
function SelectComponent_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("value", item_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.key ? item_r2[ctx_r0.key] : item_r2, " ");
} }
function SelectComponent_mat_error_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-error", 5);
    ɵngcc0.ɵɵlistener("click", function SelectComponent_mat_error_5_Template_mat_error_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.linkClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.error, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.error);
} }
function CheckboxComponent_mat_error_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-error", 4);
    ɵngcc0.ɵɵlistener("click", function CheckboxComponent_mat_error_3_Template_mat_error_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.linkClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("innerHTML", ctx_r0.error, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.error);
} }
function ToastComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelement(1, "zip-icon", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r0.icon);
} }
const _c3 = ["autosize"];
function TextAreaComponent_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-error", 4);
    ɵngcc0.ɵɵlistener("click", function TextAreaComponent_mat_error_7_Template_mat_error_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.linkClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("innerHTML", ctx_r1.error, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.error);
} }
let IconComponent = class IconComponent {
    constructor() {
        this.asset = '';
        this.icon = '';
        this.type = 'core-icons';
    }
    ngOnInit() {
        this.icon = this.class ? this.class : '';
        switch (this.type) {
            case 'core-icons':
            case 'glyphicons':
                this.useImg = true;
                this.asset = `https://zip.co/assets/zip/${this.type}/${this.src}.svg`;
                break;
            case 'fearless-icons':
                this.useImg = true;
                this.asset = `https://zip.co/assets/fearless/icons/${this.src}.svg`;
                break;
            case 'icomoon':
            default:
                this.useImg = false;
                this.icon = `${this.icon} zip-icon zip-icon-${this.src}`;
                break;
        }
    }
};
IconComponent.ɵfac = function IconComponent_Factory(t) { return new (t || IconComponent)(); };
IconComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IconComponent, selectors: [["zip-icon"]], hostVars: 1, hostBindings: function IconComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.icon);
    } }, inputs: { type: "type", class: "class", src: "src" }, decls: 1, vars: 1, consts: [["alt", "icon", 3, "src", 4, "ngIf"], ["alt", "icon", 3, "src"]], template: function IconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, IconComponent_img_0_Template, 1, 1, "img", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.useImg);
    } }, directives: [ɵngcc1.NgIf], styles: ["@import url(https://zip.co/assets/zip/icons/style.css);[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}img[_ngcontent-%COMP%]{width:inherit;height:inherit}"] });
__decorate([
    HostBinding('attr.class')
], IconComponent.prototype, "icon", void 0);
__decorate([
    Input()
], IconComponent.prototype, "class", void 0);
__decorate([
    Input()
], IconComponent.prototype, "type", void 0);
__decorate([
    Input()
], IconComponent.prototype, "src", void 0);

let ZipStyleguideIconsModule = class ZipStyleguideIconsModule {
};
ZipStyleguideIconsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ZipStyleguideIconsModule });
ZipStyleguideIconsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ZipStyleguideIconsModule_Factory(t) { return new (t || ZipStyleguideIconsModule)(); }, imports: [[CommonModule]] });

let ButtonComponent = class ButtonComponent {
    constructor() {
        this.theme = 'default';
        this.disabled = false;
        this.type = 'button';
        this.isLoading = null;
        this.loadingFinished = false;
    }
    set loading(isLoading) {
        if (this.isLoading !== null && !this.isLoading) {
            this.loadingFinished = true;
        }
        this.isLoading = isLoading;
    }
};
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["zip-button"]], inputs: { theme: "theme", disabled: "disabled", type: "type", loading: "loading" }, ngContentSelectors: _c1, decls: 3, vars: 7, consts: [[3, "type", "ngClass", "disabled"], ["class", "loader", 4, "ngIf"], ["class", "content", 3, "post-loading", 4, "ngIf"], [1, "loader"], [1, "content"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵtemplate(1, ButtonComponent_div_1_Template, 4, 0, "div", 1);
        ɵngcc0.ɵɵtemplate(2, ButtonComponent_div_2_Template, 2, 2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("type", ctx.type)("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx.theme))("disabled", ctx.disabled !== false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoading);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: ["button[_ngcontent-%COMP%]{font-family:\"Sharp Grotesk Medium\",sans-serif;height:50px;width:inherit;border-radius:8px;font-weight:500;font-size:14px;line-height:20px;letter-spacing:.5px;cursor:pointer}button[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}button.secondary[_ngcontent-%COMP%]:active, button.secondary[_ngcontent-%COMP%]:focus, button[_ngcontent-%COMP%]:active, button[_ngcontent-%COMP%]:focus{outline:0}button[disabled][_ngcontent-%COMP%]{cursor:default;pointer-events:none;opacity:.4}button.tertiary[_ngcontent-%COMP%]{line-height:normal}button.tertiary[_ngcontent-%COMP%]:active, button.tertiary[_ngcontent-%COMP%]:focus{outline:0}button.icon[_ngcontent-%COMP%]{border-radius:50%;width:56px;height:56px}button.icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:30px;height:30px}.loader[_ngcontent-%COMP%]{cursor:default;pointer-events:none}.loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{width:6px;height:6px;margin:0 5px;border-radius:50%;display:inline-block;-webkit-animation-name:loading;animation-name:loading;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2){-webkit-animation-delay:.4s;animation-delay:.4s}.loader[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(3){-webkit-animation-delay:.8s;animation-delay:.8s}@-webkit-keyframes loading{50%{-webkit-transform:scale(1.6);transform:scale(1.6)}}@keyframes loading{50%{-webkit-transform:scale(1.6);transform:scale(1.6)}}"] });
__decorate([
    Input()
], ButtonComponent.prototype, "theme", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "type", void 0);
__decorate([
    Input()
], ButtonComponent.prototype, "loading", null);

let WebModalMobileComponent = class WebModalMobileComponent {
    constructor(bottomSheetRef, data) {
        this.bottomSheetRef = bottomSheetRef;
        this.data = data;
    }
    get centered() {
        return this.data.alignment === 'center';
    }
    confirm() {
        this.bottomSheetRef.dismiss(true);
    }
    close() {
        this.bottomSheetRef.dismiss(false);
    }
};
WebModalMobileComponent.ɵfac = function WebModalMobileComponent_Factory(t) { return new (t || WebModalMobileComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MatBottomSheetRef), ɵngcc0.ɵɵdirectiveInject(MAT_BOTTOM_SHEET_DATA)); };
WebModalMobileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WebModalMobileComponent, selectors: [["zip-web-modal-mobile"]], decls: 7, vars: 5, consts: [["class", "web-modal-icon", "theme", "icon", 4, "ngIf"], ["mat-dialog-title", "", 1, "web-modal-title"], [1, "web-modal-content", 3, "innerHTML"], [1, "web-modal-actions", "center"], ["theme", "text", "class", "left", 3, "click", 4, "ngIf"], ["class", "right", 3, "click", 4, "ngIf"], ["theme", "icon", 1, "web-modal-icon"], [3, "type", "src", 4, "ngIf"], [3, "type", "src"], ["theme", "text", 1, "left", 3, "click"], [1, "right", 3, "click"]], template: function WebModalMobileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, WebModalMobileComponent_zip_button_0_Template, 2, 1, "zip-button", 0);
        ɵngcc0.ɵɵelementStart(1, "h3", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "mat-dialog-content", 2);
        ɵngcc0.ɵɵelementStart(4, "mat-dialog-actions", 3);
        ɵngcc0.ɵɵtemplate(5, WebModalMobileComponent_zip_button_5_Template, 2, 1, "zip-button", 4);
        ɵngcc0.ɵɵtemplate(6, WebModalMobileComponent_zip_button_6_Template, 2, 1, "zip-button", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.data.message, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.actionLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.actionRight);
    } }, directives: [ɵngcc1.NgIf, ɵngcc3.MatDialogTitle, ɵngcc3.MatDialogContent, ɵngcc3.MatDialogActions, ButtonComponent,
        IconComponent], styles: ["[_nghost-%COMP%]{background-color:#fff;display:block;width:100%}[_nghost-%COMP%]   *[_ngcontent-%COMP%]{color:#1a0826}[_nghost-%COMP%]   .web-modal-title[_ngcontent-%COMP%]{font-family:\"Cooper Lt BT\",sans-serif;font-weight:400;font-size:28px;line-height:34px;margin-bottom:16px!important;margin-top:0!important}[_nghost-%COMP%]   .web-modal-content[_ngcontent-%COMP%]{margin:0 0 16px;padding:0;width:inherit;font-family:\"Sharp Grotesk Book\",sans-serif;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.4px}[_nghost-%COMP%]   .web-modal-actions[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-wrap:wrap;-webkit-box-align:center;align-items:center;-webkit-box-pack:justify;justify-content:space-between;padding:0;margin:32px 0 0}[_nghost-%COMP%]   .web-modal-actions.center[_ngcontent-%COMP%]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;flex-direction:column-reverse}[_nghost-%COMP%]   .web-modal-actions.center[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .web-modal-actions.center[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .left[_ngcontent-%COMP%]{margin-right:auto}[_nghost-%COMP%]   .right[_ngcontent-%COMP%]{margin-left:auto}[_nghost-%COMP%]   .web-modal-icon[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin-bottom:16px}[_nghost-%COMP%]   .web-modal-icon[_ngcontent-%COMP%]     button{cursor:initial}[_nghost-%COMP%]   .web-modal-icon[_ngcontent-%COMP%]     button:hover{background-color:currentColor}  .mat-dialog-content p:not(:last-child){margin:0 0 16px}  .mat-dialog-content p:last-child{margin:0}  zip-button.right button{padding:15px 32px}  .web-modal-container{margin:32px;-ms-grid-row-align:center;align-self:center}  .web-modal-container .mat-dialog-container{padding:32px;border-radius:8px;box-shadow:0 0 36px rgba(0,0,0,.08)}  .web-modal-mobile-container{padding:32px 24px;border-radius:8px;box-shadow:0 0 36px rgba(0,0,0,.08)}  .web-modal-backdrop{background-color:rgba(255,255,255,.2);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}"] });
WebModalMobileComponent.ctorParameters = () => [
    { type: MatBottomSheetRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_BOTTOM_SHEET_DATA,] }] }
];
WebModalMobileComponent = __decorate([ __param(1, Inject(MAT_BOTTOM_SHEET_DATA))
], WebModalMobileComponent);

let WebModalComponent = class WebModalComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    get centered() {
        return this.data.alignment === 'center';
    }
    confirm() {
        this.dialogRef.close(true);
    }
    close() {
        this.dialogRef.close(false);
    }
};
WebModalComponent.ɵfac = function WebModalComponent_Factory(t) { return new (t || WebModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
WebModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WebModalComponent, selectors: [["zip-web-modal"]], decls: 7, vars: 8, consts: [["class", "web-modal-icon", "theme", "icon", 4, "ngIf"], ["mat-dialog-title", "", 1, "web-modal-title"], [1, "web-modal-content", 3, "innerHTML"], [1, "web-modal-actions", 3, "ngClass"], ["theme", "text", "class", "left", 3, "click", 4, "ngIf"], ["class", "right", 3, "click", 4, "ngIf"], ["theme", "icon", 1, "web-modal-icon"], [3, "type", "src", 4, "ngIf"], [3, "type", "src"], ["theme", "text", 1, "left", 3, "click"], [1, "right", 3, "click"]], template: function WebModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, WebModalComponent_zip_button_0_Template, 2, 1, "zip-button", 0);
        ɵngcc0.ɵɵelementStart(1, "h3", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "mat-dialog-content", 2);
        ɵngcc0.ɵɵelementStart(4, "mat-dialog-actions", 3);
        ɵngcc0.ɵɵtemplate(5, WebModalComponent_zip_button_5_Template, 2, 1, "zip-button", 4);
        ɵngcc0.ɵɵtemplate(6, WebModalComponent_zip_button_6_Template, 2, 1, "zip-button", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.data.message, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c2, ctx.centered));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.actionLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.actionRight);
    } }, directives: [ɵngcc1.NgIf, ɵngcc3.MatDialogTitle, ɵngcc3.MatDialogContent, ɵngcc3.MatDialogActions, ɵngcc1.NgClass, ButtonComponent,
        IconComponent], styles: ["[_nghost-%COMP%]{background-color:#fff;display:block;width:100%}[_nghost-%COMP%]   *[_ngcontent-%COMP%]{color:#1a0826}[_nghost-%COMP%]   .web-modal-title[_ngcontent-%COMP%]{font-family:\"Cooper Lt BT\",sans-serif;font-weight:400;font-size:28px;line-height:34px;margin-bottom:16px!important;margin-top:0!important}[_nghost-%COMP%]   .web-modal-content[_ngcontent-%COMP%]{margin:0 0 16px;padding:0;width:inherit;font-family:\"Sharp Grotesk Book\",sans-serif;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.4px}[_nghost-%COMP%]   .web-modal-actions[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-wrap:wrap;-webkit-box-align:center;align-items:center;-webkit-box-pack:justify;justify-content:space-between;padding:0;margin:32px 0 0}[_nghost-%COMP%]   .web-modal-actions.center[_ngcontent-%COMP%]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;flex-direction:column-reverse}[_nghost-%COMP%]   .web-modal-actions.center[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .web-modal-actions.center[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .left[_ngcontent-%COMP%]{margin-right:auto}[_nghost-%COMP%]   .right[_ngcontent-%COMP%]{margin-left:auto}[_nghost-%COMP%]   .web-modal-icon[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin-bottom:16px}[_nghost-%COMP%]   .web-modal-icon[_ngcontent-%COMP%]     button{cursor:initial}[_nghost-%COMP%]   .web-modal-icon[_ngcontent-%COMP%]     button:hover{background-color:currentColor}  .mat-dialog-content p:not(:last-child){margin:0 0 16px}  .mat-dialog-content p:last-child{margin:0}  zip-button.right button{padding:15px 32px}  .web-modal-container{margin:32px;-ms-grid-row-align:center;align-self:center}  .web-modal-container .mat-dialog-container{padding:32px;border-radius:8px;box-shadow:0 0 36px rgba(0,0,0,.08)}  .web-modal-mobile-container{padding:32px 24px;border-radius:8px;box-shadow:0 0 36px rgba(0,0,0,.08)}  .web-modal-backdrop{background-color:rgba(255,255,255,.2);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}"] });
WebModalComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
WebModalComponent = __decorate([ __param(1, Inject(MAT_DIALOG_DATA))
], WebModalComponent);

let WebModalService = class WebModalService {
    constructor(breakpointObserver, dialog, bottomSheet) {
        this.breakpointObserver = breakpointObserver;
        this.dialog = dialog;
        this.bottomSheet = bottomSheet;
        this.isTablet$ = this.breakpointObserver
            .observe(['(min-width: 600px)'])
            .pipe(map((result) => result.matches));
    }
    open({ title = '', message = '', actionLeft = '', actionRight = '', alignment = '', iconType = '', icon = '', autofocus = false, }) {
        return __awaiter(this, void 0, void 0, function* () {
            let dialogRef;
            let bottomSheetRef;
            const dialogResult$ = new Subject();
            const mobileDialogSubscriptions = this.isTablet$.subscribe((isTablet) => {
                var _a, _b;
                if (isTablet) {
                    (_a = bottomSheetRef) === null || _a === void 0 ? void 0 : _a.dismiss();
                    bottomSheetRef = undefined;
                    dialogRef = this.dialog.open(WebModalComponent, {
                        panelClass: 'web-modal-container',
                        data: {
                            title,
                            message,
                            actionLeft,
                            actionRight,
                            alignment,
                            iconType,
                            icon,
                        },
                        maxWidth: '520px',
                        minWidth: '420px',
                        autoFocus: autofocus,
                        backdropClass: 'web-modal-backdrop',
                    });
                    dialogRef.afterClosed().subscribe((data) => {
                        if (!bottomSheetRef) {
                            mobileDialogSubscriptions.unsubscribe();
                            dialogResult$.next(data);
                            dialogResult$.complete();
                        }
                    });
                }
                else {
                    (_b = dialogRef) === null || _b === void 0 ? void 0 : _b.close();
                    dialogRef = undefined;
                    bottomSheetRef = this.bottomSheet.open(WebModalMobileComponent, {
                        panelClass: 'web-modal-mobile-container',
                        data: {
                            title,
                            message,
                            actionLeft,
                            actionRight,
                            alignment,
                            iconType,
                            icon,
                        },
                        autoFocus: autofocus,
                        backdropClass: 'web-modal-backdrop',
                    });
                    bottomSheetRef.afterDismissed().subscribe((data) => {
                        if (!dialogRef) {
                            mobileDialogSubscriptions.unsubscribe();
                            dialogResult$.next(data);
                            dialogResult$.complete();
                        }
                    });
                }
            });
            return dialogResult$.toPromise();
        });
    }
};
WebModalService.ɵfac = function WebModalService_Factory(t) { return new (t || WebModalService)(ɵngcc0.ɵɵinject(ɵngcc4.BreakpointObserver), ɵngcc0.ɵɵinject(ɵngcc3.MatDialog), ɵngcc0.ɵɵinject(ɵngcc2.MatBottomSheet)); };
WebModalService.ctorParameters = () => [
    { type: BreakpointObserver },
    { type: MatDialog },
    { type: MatBottomSheet }
];
WebModalService.ɵprov = ɵɵdefineInjectable({ factory: function WebModalService_Factory() { return new WebModalService(ɵɵinject(BreakpointObserver), ɵɵinject(MatDialog), ɵɵinject(MatBottomSheet)); }, token: WebModalService, providedIn: "root" });

var ConfirmResult;
(function (ConfirmResult) {
    ConfirmResult["cancelled"] = "CANCELLED";
    ConfirmResult["confirmed"] = "CONFIRMED";
})(ConfirmResult || (ConfirmResult = {}));

let ConfirmDialogService = class ConfirmDialogService {
    constructor(webModalService) {
        this.webModalService = webModalService;
    }
    open(title = '', message = '') {
        return __awaiter(this, void 0, void 0, function* () {
            return this.webModalService.open({
                title,
                message,
                actionRight: 'Confirm',
                actionLeft: 'Cancel',
                alignment: 'center'
            }).then(result => {
                return result ? ConfirmResult.confirmed : ConfirmResult.cancelled;
            });
        });
    }
};
ConfirmDialogService.ɵfac = function ConfirmDialogService_Factory(t) { return new (t || ConfirmDialogService)(ɵngcc0.ɵɵinject(WebModalService)); };
ConfirmDialogService.ctorParameters = () => [
    { type: WebModalService }
];
ConfirmDialogService.ɵprov = ɵɵdefineInjectable({ factory: function ConfirmDialogService_Factory() { return new ConfirmDialogService(ɵɵinject(WebModalService)); }, token: ConfirmDialogService, providedIn: "root" });

let LoaderComponent = class LoaderComponent {
    constructor() {
        this.width = '80px';
        this.options = {
            path: '',
            autoplay: true,
            loop: true,
        };
    }
    ngOnChanges() {
        if (this.type) {
            this.updateAnimation(this.type);
        }
    }
    updateAnimation(type) {
        let animationPath;
        switch (type) {
            case 'consumer':
                animationPath = 'https://zip.co/assets/fearless/animation/spinner-light.json';
                break;
            case 'consumer-dark':
                animationPath = 'https://zip.co/assets/fearless/animation/spinner-dark.json';
                break;
            case 'business':
                animationPath = 'https://zip.co/assets/business/animation/spinner-light.json';
                break;
            case 'business-dark':
                animationPath = 'https://zip.co/assets/business/animation/spinner-dark.json';
                break;
        }
        this.options = Object.assign(Object.assign({}, this.options), { path: animationPath });
    }
};
LoaderComponent.ɵfac = function LoaderComponent_Factory(t) { return new (t || LoaderComponent)(); };
LoaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoaderComponent, selectors: [["zip-loader"]], inputs: { width: "width", type: "type", height: "height" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 3, consts: [[3, "options", "width", "height"]], template: function LoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "ng-lottie", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("options", ctx.options)("width", ctx.width)("height", ctx.height);
    } }, directives: [ɵngcc5.LottieComponent], encapsulation: 2 });
__decorate([
    Input()
], LoaderComponent.prototype, "type", void 0);
__decorate([
    Input()
], LoaderComponent.prototype, "width", void 0);
__decorate([
    Input()
], LoaderComponent.prototype, "height", void 0);

let ProgressBarComponent = class ProgressBarComponent {
    ngOnInit() {
        // currentStep = 0 is 1 bar
        // currentStep = totalStep - 1 is full bar
        this.steps = Array(this.totalStep).map((x, i) => i);
        document.documentElement.style.setProperty(`--totalStep`, this.totalStep.toString());
    }
};
ProgressBarComponent.ɵfac = function ProgressBarComponent_Factory(t) { return new (t || ProgressBarComponent)(); };
ProgressBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ProgressBarComponent, selectors: [["zip-progress-bar"]], inputs: { currentStep: "currentStep", totalStep: "totalStep", imageUrl: "imageUrl", message: "message" }, decls: 4, vars: 3, consts: [[3, "src", 4, "ngIf"], [1, "bar"], ["class", "step", 3, "active", 4, "ngFor", "ngForOf"], ["class", "message", 3, "innerHtml", 4, "ngIf"], [3, "src"], [1, "step"], [1, "message", 3, "innerHtml"]], template: function ProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ProgressBarComponent_img_0_Template, 1, 1, "img", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, ProgressBarComponent_div_2_Template, 1, 2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ProgressBarComponent_span_3_Template, 2, 2, "span", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], styles: ["img[_ngcontent-%COMP%]{height:28px}[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:justify;justify-content:space-between}.bar[_ngcontent-%COMP%]{margin:0 8px 0 24px;padding:12px 0;display:-webkit-box;display:flex;width:100%;-webkit-box-align:center;align-items:center}.step[_ngcontent-%COMP%]{width:calc((100% - (var(--totalStep) * 2px))/ var(--totalStep));height:4px;margin-right:2px;background:#e7e4e4;-webkit-transform:skewX(10deg);transform:skewX(10deg)}.step[_ngcontent-%COMP%]:first-of-type::before, .step[_ngcontent-%COMP%]:last-of-type::before{position:absolute;content:\"\";height:inherit;width:10%;background-color:inherit;-webkit-transform:skewX(-10deg);transform:skewX(-10deg);-webkit-transform-origin:bottom left;transform-origin:bottom left}.step[_ngcontent-%COMP%]:first-of-type::before{left:-1px}.step[_ngcontent-%COMP%]:last-of-type{margin-right:0}.step[_ngcontent-%COMP%]:last-of-type::before{right:0}.message[_ngcontent-%COMP%]{color:#959196;font-size:11px;line-height:18px;white-space:nowrap;min-width:4%;text-align:right}"] });
__decorate([
    Input()
], ProgressBarComponent.prototype, "currentStep", void 0);
__decorate([
    Input()
], ProgressBarComponent.prototype, "totalStep", void 0);
__decorate([
    Input()
], ProgressBarComponent.prototype, "imageUrl", void 0);
__decorate([
    Input()
], ProgressBarComponent.prototype, "message", void 0);

let LoadingSpinnerComponent = class LoadingSpinnerComponent {
};
LoadingSpinnerComponent.ɵfac = function LoadingSpinnerComponent_Factory(t) { return new (t || LoadingSpinnerComponent)(); };
LoadingSpinnerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoadingSpinnerComponent, selectors: [["zip-loading-spinner"]], decls: 5, vars: 0, consts: [[1, "zip-spinner"], ["id", "spin1", 1, "spin"], ["id", "spin2", 1, "spin"], ["id", "spin3", 1, "spin"], ["id", "spin4", 1, "spin"]], template: function LoadingSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["*[_ngcontent-%COMP%]{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-Mac-osx-font-smoothing:grayscale;box-sizing:border-box;list-style-type:none;text-decoration:none;color:inherit;font-family:Rubik,sans-serif}[_ngcontent-%COMP%]:active, [_ngcontent-%COMP%]:focus{outline:0}.align-center[_ngcontent-%COMP%]{text-align:center}.align-left[_ngcontent-%COMP%]{text-align:left}.align-right[_ngcontent-%COMP%]{text-align:right}a[_ngcontent-%COMP%], h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{margin:0;padding:0}h1[_ngcontent-%COMP%], h2[_ngcontent-%COMP%], h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]{font-weight:600}h1[_ngcontent-%COMP%]{font-size:28px;line-height:32px;margin-bottom:28px}@media (min-width:769px){h1[_ngcontent-%COMP%]{font-size:30px;line-height:34px}}h2[_ngcontent-%COMP%]{font-size:26px;line-height:30px;margin-bottom:24px}@media (min-width:769px){h2[_ngcontent-%COMP%]{font-size:28px;line-height:32px}}h3[_ngcontent-%COMP%]{font-size:24px;line-height:28px;margin-bottom:20px}@media (min-width:769px){h3[_ngcontent-%COMP%]{font-size:26px;line-height:30px}}h4[_ngcontent-%COMP%]{font-size:22px;line-height:26px;margin-bottom:16px}@media (min-width:769px){h4[_ngcontent-%COMP%]{font-size:24px;line-height:28px}}h5[_ngcontent-%COMP%]{font-size:20px;line-height:22px;margin-bottom:12px}@media (min-width:769px){h5[_ngcontent-%COMP%]{font-size:22px;line-height:26px}}h6[_ngcontent-%COMP%]{font-size:18px;line-height:20px;margin-bottom:8px}@media (min-width:769px){h6[_ngcontent-%COMP%]{font-size:20px;line-height:24px}}a[_ngcontent-%COMP%]{color:#3e85f4;text-decoration:underline}a[_ngcontent-%COMP%], label[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-size:14px;line-height:18px;font-weight:400;margin-bottom:4px}@media (min-width:769px){a[_ngcontent-%COMP%], label[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-size:16px;line-height:22px;margin-bottom:8px}}label[_ngcontent-%COMP%]{display:block}em[_ngcontent-%COMP%]{font-size:inherit;font-weight:600}code[_ngcontent-%COMP%]{display:block;font-size:14px;font-family:Inconsolata,monospace;padding:10px;background:#eee;border-radius:4px;white-space:pre-wrap}.margin-bottom-level-0[_ngcontent-%COMP%]{margin-bottom:0!important}.margin-bottom-level-1[_ngcontent-%COMP%]{margin-bottom:4px!important}.margin-bottom-level-2[_ngcontent-%COMP%]{margin-bottom:8px!important}.margin-bottom-level-3[_ngcontent-%COMP%]{margin-bottom:12px!important}.margin-bottom-level-4[_ngcontent-%COMP%]{margin-bottom:16px!important}.margin-bottom-level-5[_ngcontent-%COMP%]{margin-bottom:20px!important}.margin-bottom-level-6[_ngcontent-%COMP%]{margin-bottom:24px!important}.margin-bottom-level-7[_ngcontent-%COMP%]{margin-bottom:28px!important}.margin-bottom-level-8[_ngcontent-%COMP%]{margin-bottom:32px!important}.margin-bottom-level-9[_ngcontent-%COMP%]{margin-bottom:36px!important}.margin-bottom-level-10[_ngcontent-%COMP%]{margin-bottom:40px!important}.zip-spinner[_ngcontent-%COMP%]{width:70px;height:70px;margin:24px auto;position:relative}.spin[_ngcontent-%COMP%]{width:70px;height:70px;position:absolute}.spin[_ngcontent-%COMP%]:before{content:\"\";height:28px;width:28px;border-radius:50%;position:absolute}#spin1[_ngcontent-%COMP%]:before{background-color:#f8991c}#spin2[_ngcontent-%COMP%]:before{background-color:#1b1e63}#spin3[_ngcontent-%COMP%]:before{background-color:#00aeb8}#spin4[_ngcontent-%COMP%]:before{background-color:#f15c3e}#spin1[_ngcontent-%COMP%]{-webkit-transform:rotate(360deg);transform:rotate(360deg);-webkit-animation:1s linear infinite timer1;animation:1s linear infinite timer1}#spin2[_ngcontent-%COMP%]{-webkit-transform:rotate(270deg);transform:rotate(270deg);-webkit-animation:1s linear -.25s infinite timer1;animation:1s linear -.25s infinite timer1}#spin3[_ngcontent-%COMP%]{-webkit-transform:rotate(180deg);transform:rotate(180deg);-webkit-animation:1s linear -.5s infinite timer1;animation:1s linear -.5s infinite timer1}#spin4[_ngcontent-%COMP%]{-webkit-transform:rotate(90deg);transform:rotate(90deg);-webkit-animation:1s linear -.75s infinite timer1;animation:1s linear -.75s infinite timer1}@-webkit-keyframes timer1{0%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}25%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}75%{-webkit-transform:rotate(90deg);transform:rotate(90deg)}100%{-webkit-transform:rotate(0);transform:rotate(0)}}@keyframes timer1{0%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}25%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}75%{-webkit-transform:rotate(90deg);transform:rotate(90deg)}100%{-webkit-transform:rotate(0);transform:rotate(0)}}"] });

let TableComponent = class TableComponent {
};
TableComponent.ɵfac = function TableComponent_Factory(t) { return new (t || TableComponent)(); };
TableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableComponent, selectors: [["zip-table"]], ngContentSelectors: _c1, decls: 1, vars: 0, template: function TableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[_nghost-%COMP%]    {border-bottom:1px solid #e7e4e4}[_nghost-%COMP%]    >th, [_nghost-%COMP%]    >tr{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-flow:row wrap;-webkit-box-pack:justify;justify-content:space-between}[_nghost-%COMP%]    >th>[width=\"1\"], [_nghost-%COMP%]    >tr>[width=\"1\"]{width:calc(100% / 12 * 1)}[_nghost-%COMP%]    >th>[width=\"2\"], [_nghost-%COMP%]    >tr>[width=\"2\"]{width:calc(100% / 12 * 2)}[_nghost-%COMP%]    >th>[width=\"3\"], [_nghost-%COMP%]    >tr>[width=\"3\"]{width:calc(100% / 12 * 3)}[_nghost-%COMP%]    >th>[width=\"4\"], [_nghost-%COMP%]    >tr>[width=\"4\"]{width:calc(100% / 12 * 4)}[_nghost-%COMP%]    >th>[width=\"5\"], [_nghost-%COMP%]    >tr>[width=\"5\"]{width:calc(100% / 12 * 5)}[_nghost-%COMP%]    >th>[width=\"6\"], [_nghost-%COMP%]    >tr>[width=\"6\"]{width:calc(100% / 12 * 6)}[_nghost-%COMP%]    >th>[width=\"7\"], [_nghost-%COMP%]    >tr>[width=\"7\"]{width:calc(100% / 12 * 7)}[_nghost-%COMP%]    >th>[width=\"8\"], [_nghost-%COMP%]    >tr>[width=\"8\"]{width:calc(100% / 12 * 8)}[_nghost-%COMP%]    >th>[width=\"9\"], [_nghost-%COMP%]    >tr>[width=\"9\"]{width:calc(100% / 12 * 9)}[_nghost-%COMP%]    >th>[width=\"10\"], [_nghost-%COMP%]    >tr>[width=\"10\"]{width:calc(100% / 12 * 10)}[_nghost-%COMP%]    >th>[width=\"11\"], [_nghost-%COMP%]    >tr>[width=\"11\"]{width:calc(100% / 12 * 11)}[_nghost-%COMP%]    >th>[width=\"12\"], [_nghost-%COMP%]    >tr>[width=\"12\"]{width:calc(100% / 12 * 12)}[_nghost-%COMP%]    >th{border-bottom:1px solid #e7e4e4}[_nghost-%COMP%]    >th>*{font-size:14px}[_nghost-%COMP%]    >th>*, [_nghost-%COMP%]    >tr>*{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;min-height:44px;padding:10px 0;box-sizing:border-box;font-size:15px;font-weight:400}[_nghost-%COMP%]    >th>strong, [_nghost-%COMP%]    >tr>strong{color:#1a0826;font-weight:400}"] });

var WebInputComponent_1;
let WebInputComponent = WebInputComponent_1 = class WebInputComponent {
    constructor() {
        this.formControl = new FormControl();
        this.matAutocomplete = null;
        this.type = 'text';
        this.errorMessages = {};
        this.value = '';
        this.hintClicked = new EventEmitter();
        this.errorClicked = new EventEmitter();
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    hintClick() {
        this.hintClicked.emit(true);
    }
    errorClick() {
        this.errorClicked.emit(true);
    }
    get invalid() {
        return this.formControl.status === 'INVALID';
    }
    get error() {
        if (!this.formControl.errors) {
            return null;
        }
        const error = Object.keys(this.formControl.errors)
            .map(validationError => this.errorMessages[validationError])[0];
        return error || 'Invalid';
    }
    writeValue(value) {
        if (value === this.formControl.value) {
            return;
        }
        this.formControl.setValue(value);
        this.onChangeCallback(value);
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
};
WebInputComponent.ɵfac = function WebInputComponent_Factory(t) { return new (t || WebInputComponent)(); };
WebInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WebInputComponent, selectors: [["zip-web-input"]], inputs: { formControl: "formControl", matAutocomplete: "matAutocomplete", type: "type", errorMessages: "errorMessages", value: "value", label: "label", placeholder: "placeholder", icon: "icon", hint: "hint", prefix: "prefix" }, outputs: { hintClicked: "hintClicked", errorClicked: "errorClicked" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => WebInputComponent_1),
                multi: true
            }
        ])], decls: 9, vars: 12, consts: [[1, "label"], ["appearance", "outline", 1, "zip"], ["matInput", "", 3, "placeholder", "formControl", "type", "value", "matAutocomplete", "matAutocompleteDisabled"], [3, "innerHTML", "click"], [3, "innerHTML", "click", 4, "ngIf"], ["class", "prefix", "matPrefix", "", 4, "ngIf"], ["matSuffix", "", 4, "ngIf"], ["matPrefix", "", 1, "prefix"], ["matSuffix", ""], ["src", "alert"]], template: function WebInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "mat-form-field", 1);
        ɵngcc0.ɵɵelement(3, "input", 2);
        ɵngcc0.ɵɵelementStart(4, "mat-hint", 3);
        ɵngcc0.ɵɵlistener("click", function WebInputComponent_Template_mat_hint_click_4_listener() { return ctx.hintClick(); });
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, WebInputComponent_mat_error_6_Template, 2, 2, "mat-error", 4);
        ɵngcc0.ɵɵtemplate(7, WebInputComponent_span_7_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵtemplate(8, WebInputComponent_span_8_Template, 2, 0, "span", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("formControl", ctx.formControl)("type", ctx.type)("value", ctx.value)("matAutocomplete", ctx.matAutocomplete)("matAutocompleteDisabled", ctx.matAutocomplete === null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("innerHTML", ctx.hint, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.hint);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControl.invalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prefix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControl.touched && ctx.formControl.invalid);
    } }, directives: [ɵngcc6.MatFormField, ɵngcc7.MatInput, ɵngcc8.DefaultValueAccessor, ɵngcc9.MatAutocompleteTrigger, ɵngcc8.NgControlStatus, ɵngcc8.FormControlDirective, ɵngcc6.MatHint, ɵngcc1.NgIf, ɵngcc6.MatError, ɵngcc6.MatPrefix, ɵngcc6.MatSuffix, IconComponent], styles: [".label[_ngcontent-%COMP%]{font-size:14px;line-height:1.46;margin-top:0;margin-bottom:4px}input[_ngcontent-%COMP%], span[_ngcontent-%COMP%]{font-family:\"Sharp Grotesk Book\",sans-serif;font-size:14px;line-height:20px;letter-spacing:.4px}.mat-form-field[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]     .mat-form-field-appearance-outline .mat-form-field-infix{padding:14px 0}[_nghost-%COMP%]     .mat-form-field-infix{border-top:none}[_nghost-%COMP%]     .mat-form-field-prefix{top:-.15em!important}[_nghost-%COMP%]     .mat-form-field-suffix{top:.65em!important}[_nghost-%COMP%]     .mat-form-field-flex, [_nghost-%COMP%]     .mat-form-field-outline, [_nghost-%COMP%]     .mat-form-field-outline-thick, [_nghost-%COMP%]     .mat-form-field-wrapper{height:45px!important}"] });
__decorate([
    Input()
], WebInputComponent.prototype, "label", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "icon", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "hint", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "prefix", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "formControl", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "matAutocomplete", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "type", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "errorMessages", void 0);
__decorate([
    Input()
], WebInputComponent.prototype, "value", void 0);
__decorate([
    Output()
], WebInputComponent.prototype, "hintClicked", void 0);
__decorate([
    Output()
], WebInputComponent.prototype, "errorClicked", void 0);

// Required for Lottie Animation Player
function playerFactory() {
    return player;
}
let ZipStyleguideWebModule = class ZipStyleguideWebModule {
};
ZipStyleguideWebModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ZipStyleguideWebModule });
ZipStyleguideWebModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ZipStyleguideWebModule_Factory(t) { return new (t || ZipStyleguideWebModule)(); }, providers: [
        ConfirmDialogService,
        WebModalService
    ], imports: [[
            CommonModule,
            ReactiveFormsModule,
            MatAutocompleteModule,
            MatDialogModule,
            MatBottomSheetModule,
            MatInputModule,
            FormsModule,
            ZipStyleguideIconsModule,
            LottieModule.forRoot({ player: playerFactory }),
        ]] });

let ProgressBarService = class ProgressBarService {
    constructor(
    // Works with any type of enum, except ones with string as value
    enumObject) {
        this.enumObject = enumObject;
        this.stringIsNumber = (value) => isNaN(Number(value)) === false;
    }
    getPreviousStepString(currentStep) {
        const previousStepIndex = this.getPreviousStepIndex(currentStep);
        return this.enumObject[previousStepIndex];
    }
    getPreviousStepIndex(currentStep) {
        const previousIndex = Object.keys(this.enumObject).indexOf(currentStep.toString()) - 1;
        return previousIndex === -1 ? 0 : previousIndex;
    }
    getNextStepString(currentStep) {
        const nextStepIndex = this.getNextStepIndex(currentStep);
        return this.enumObject[nextStepIndex];
    }
    getNextStepIndex(currentStep) {
        const nextIndex = Object.keys(this.enumObject).indexOf(currentStep.toString()) + 1;
        const totalStep = this.getTotalSteps();
        return nextIndex === totalStep ? totalStep - 1 : nextIndex;
    }
    getTotalSteps() {
        // Reverse mapping in typescript enums makes the length doubled
        // This does not work with enums that have string values
        // refer to: https://stackoverflow.com/a/38034825/15119714
        return this.toArray(this.enumObject).length;
    }
    toArray(enumObject) {
        return Object.keys(enumObject)
            .filter(this.stringIsNumber)
            .map(key => enumObject[key]);
    }
};
ProgressBarService.ɵfac = function ProgressBarService_Factory(t) { return new (t || ProgressBarService)(ɵngcc0.ɵɵinject('enumObject')); };
ProgressBarService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['enumObject',] }] }
];
ProgressBarService.ɵprov = ɵɵdefineInjectable({ factory: function ProgressBarService_Factory() { return new ProgressBarService(ɵɵinject("enumObject")); }, token: ProgressBarService, providedIn: "root" });
ProgressBarService = __decorate([ __param(0, Inject('enumObject'))
], ProgressBarService);

var InputComponent_1;
let InputComponent = InputComponent_1 = class InputComponent {
    constructor() {
        this.formControl = new FormControl();
        this.type = 'text';
        this.errorMessages = {};
        this.value = '';
        this.linkClicked = new EventEmitter();
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    linkClick() {
        this.linkClicked.emit(true);
    }
    get invalid() {
        return this.formControl.status === 'INVALID';
    }
    get error() {
        if (!this.formControl.errors) {
            return null;
        }
        const error = Object.keys(this.formControl.errors)
            .map(validationError => this.errorMessages[validationError])[0];
        return error || 'Invalid';
    }
    writeValue(value) {
        if (value === this.formControl.value) {
            return;
        }
        this.formControl.setValue(value);
        this.onChangeCallback(value);
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
};
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(); };
InputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["zip-input"]], inputs: { formControl: "formControl", type: "type", errorMessages: "errorMessages", value: "value", label: "label", placeholder: "placeholder", icon: "icon", hint: "hint" }, outputs: { linkClicked: "linkClicked" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => InputComponent_1),
                multi: true
            }
        ])], decls: 9, vars: 9, consts: [["appearance", "outline", 1, "zip"], ["matInput", "", 3, "placeholder", "formControl", "type", "value"], [3, "innerHTML", "click", 4, "ngIf"], ["matSuffix", "", 4, "ngIf"], [3, "innerHTML", "click"], ["matSuffix", ""], [3, "src"], ["type", "fearless-icons", "src", "toast-error"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵelementStart(1, "mat-label");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "input", 1);
        ɵngcc0.ɵɵelementStart(4, "mat-hint");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, InputComponent_mat_error_6_Template, 2, 2, "mat-error", 2);
        ɵngcc0.ɵɵtemplate(7, InputComponent_span_7_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵtemplate(8, InputComponent_span_8_Template, 2, 0, "span", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("formControl", ctx.formControl)("type", ctx.type)("value", ctx.value);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.hint);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControl.invalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon && !(ctx.formControl.touched && ctx.formControl.invalid));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControl.touched && ctx.formControl.invalid);
    } }, directives: [ɵngcc6.MatFormField, ɵngcc6.MatLabel, ɵngcc7.MatInput, ɵngcc8.DefaultValueAccessor, ɵngcc8.NgControlStatus, ɵngcc8.FormControlDirective, ɵngcc6.MatHint, ɵngcc1.NgIf, ɵngcc6.MatError, ɵngcc6.MatSuffix, IconComponent], styles: ["a{cursor:pointer}"] });
__decorate([
    Input()
], InputComponent.prototype, "label", void 0);
__decorate([
    Input()
], InputComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], InputComponent.prototype, "icon", void 0);
__decorate([
    Input()
], InputComponent.prototype, "hint", void 0);
__decorate([
    Input()
], InputComponent.prototype, "formControl", void 0);
__decorate([
    Input()
], InputComponent.prototype, "type", void 0);
__decorate([
    Input()
], InputComponent.prototype, "errorMessages", void 0);
__decorate([
    Input()
], InputComponent.prototype, "value", void 0);
__decorate([
    Output()
], InputComponent.prototype, "linkClicked", void 0);

var SelectComponent_1;
let SelectComponent = SelectComponent_1 = class SelectComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.items = [];
        this.key = null;
        this.placeholder = 'Please select one...';
        this.errorMessages = {};
        this.formControl = new FormControl();
        this.selectChange = new EventEmitter();
        this.linkClicked = new EventEmitter();
        this.objectComparisonFunction = (option, value) => {
            if (option && value) {
                return this.key ? option[this.key] === value[this.key] : option === value;
            }
            return false;
        };
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    set disabled(condition) {
        if (condition) {
            this.formControl.disable();
        }
        else {
            this.formControl.enable();
        }
    }
    ngAfterContentChecked() {
        this.cdr.detectChanges();
    }
    linkClick() {
        this.linkClicked.emit(true);
    }
    select(option) {
        this.selectChange.emit(option.value);
    }
    get invalid() {
        return this.formControl.status === 'INVALID';
    }
    get error() {
        if (!this.formControl.errors) {
            return null;
        }
        const error = Object.keys(this.formControl.errors)
            .map(validationError => this.errorMessages[validationError])[0];
        return error || 'Invalid';
    }
    writeValue(value) {
        if (value === this.formControl.value) {
            return;
        }
        this.formControl.setValue(value);
        this.onChangeCallback(value);
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
};
SelectComponent.ɵfac = function SelectComponent_Factory(t) { return new (t || SelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectComponent, selectors: [["zip-select"]], inputs: { items: "items", key: "key", placeholder: "placeholder", errorMessages: "errorMessages", formControl: "formControl", disabled: "disabled", label: "label" }, outputs: { selectChange: "selectChange", linkClicked: "linkClicked" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SelectComponent_1),
                multi: true
            }
        ])], decls: 6, vars: 6, consts: [["appearance", "outline"], ["disableOptionCentering", "", 3, "placeholder", "formControl", "compareWith", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "innerHTML", "click", 4, "ngIf"], [3, "value"], [3, "innerHTML", "click"]], template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵelementStart(1, "mat-label");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "mat-select", 1);
        ɵngcc0.ɵɵlistener("selectionChange", function SelectComponent_Template_mat_select_selectionChange_3_listener($event) { return ctx.select($event); });
        ɵngcc0.ɵɵtemplate(4, SelectComponent_mat_option_4_Template, 2, 2, "mat-option", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, SelectComponent_mat_error_5_Template, 2, 2, "mat-error", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("formControl", ctx.formControl)("compareWith", ctx.objectComparisonFunction);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControl.invalid);
    } }, directives: [ɵngcc6.MatFormField, ɵngcc6.MatLabel, ɵngcc10.MatSelect, ɵngcc8.NgControlStatus, ɵngcc8.FormControlDirective, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc11.MatOption, ɵngcc6.MatError], styles: ["[_nghost-%COMP%]     .mat-select-panel{margin-top:35px;padding-top:8px!important;width:100%!important}[_nghost-%COMP%]     .mat-form-field.mat-focused.mat-primary .mat-select-arrow{-webkit-transform:rotate(225deg)!important;transform:rotate(225deg)!important;margin-top:7px!important}[_nghost-%COMP%]     .mat-form-field .mat-select.mat-select-invalid .mat-select-arrow{color:#b00020!important}[_nghost-%COMP%]     .mat-form-field .mat-select.mat-select-disabled .mat-select-arrow{color:#e0dee0!important}.mat-option.mat-selected[_ngcontent-%COMP%]{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;flex-direction:row-reverse}.mat-option.mat-selected[_ngcontent-%COMP%]::before{width:1.5rem;height:1.5rem;display:inline-block;content:\"\";-webkit-mask:url(https://zip.co/assets/fearless/icons/check.svg);mask:url(https://zip.co/assets/fearless/icons/check.svg);-webkit-mask-size:cover;mask-size:cover}"] });
SelectComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], SelectComponent.prototype, "label", void 0);
__decorate([
    Input()
], SelectComponent.prototype, "items", void 0);
__decorate([
    Input()
], SelectComponent.prototype, "key", void 0);
__decorate([
    Input()
], SelectComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], SelectComponent.prototype, "errorMessages", void 0);
__decorate([
    Input()
], SelectComponent.prototype, "formControl", void 0);
__decorate([
    Input()
], SelectComponent.prototype, "disabled", null);
__decorate([
    Output()
], SelectComponent.prototype, "selectChange", void 0);
__decorate([
    Output()
], SelectComponent.prototype, "linkClicked", void 0);

var CheckboxComponent_1;
let CheckboxComponent = CheckboxComponent_1 = class CheckboxComponent {
    constructor() {
        this.formControl = new FormControl(false);
        this.errorMessages = {};
        this.linkClicked = new EventEmitter();
        this.valueChanged = new EventEmitter();
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    set disabled(condition) {
        if (condition) {
            this.formControl.disable();
        }
        else {
            this.formControl.enable();
        }
    }
    linkClick() {
        this.linkClicked.emit(true);
    }
    onValueChange(event) {
        this.valueChanged.emit(event);
    }
    get invalid() {
        return this.formControl.status === 'INVALID';
    }
    get error() {
        if (!this.formControl.errors) {
            return null;
        }
        const error = Object.keys(this.formControl.errors)
            .map(validationError => this.errorMessages[validationError])[0];
        return error || 'Invalid';
    }
    writeValue(value) {
        if (value === this.formControl.value) {
            return;
        }
        this.formControl.setValue(value);
        this.onChangeCallback(value);
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
};
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
CheckboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["zip-checkbox"]], inputs: { formControl: "formControl", errorMessages: "errorMessages", disabled: "disabled", label: "label" }, outputs: { linkClicked: "linkClicked", valueChanged: "valueChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxComponent_1),
                multi: true
            }
        ])], decls: 4, vars: 3, consts: [[3, "formControl", "change"], [3, "innerHTML"], ["ng-reflect-ng-switch", "error", 1, "mat-form-field-subscript-wrapper", "checkbox-error"], [3, "innerHTML", "click", 4, "ngIf"], [3, "innerHTML", "click"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 0);
        ɵngcc0.ɵɵlistener("change", function CheckboxComponent_Template_mat_checkbox_change_0_listener($event) { return ctx.onValueChange($event); });
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, CheckboxComponent_mat_error_3_Template, 2, 2, "mat-error", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formControl", ctx.formControl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.label, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControl.invalid && ctx.formControl.touched);
    } }, directives: [ɵngcc12.MatCheckbox, ɵngcc8.NgControlStatus, ɵngcc8.FormControlDirective, ɵngcc1.NgIf, ɵngcc6.MatError], styles: ["[_nghost-%COMP%]     .mat-checkbox-inner-container{width:21px!important;height:21px!important;margin-right:16px!important;margin-top:0!important}[_nghost-%COMP%]     .mat-checkbox-frame{border:1px solid #959196;border-radius:2px!important;width:21px;height:21px;border-width:1px!important}[_nghost-%COMP%]     .mat-checkbox-checked.mat-accent .mat-checkbox-background{width:21px;height:21px}[_nghost-%COMP%]     .mat-checkbox .mat-checkbox-ripple{height:45px!important;width:45px!important;left:calc(50% - 23px)!important;top:calc(50% - 23px)!important}[_nghost-%COMP%]     .mat-checkbox-layout .mat-checkbox-label{font-size:14px;line-height:20px;letter-spacing:.4px;white-space:normal!important;vertical-align:baseline}[_nghost-%COMP%]     .mat-checkbox-layout{vertical-align:baseline!important}.ng-invalid.ng-touched[_nghost-%COMP%]     .mat-checkbox-frame{border:1px solid #b00020!important;box-sizing:border-box;border-radius:2px!important}.mat-error[_ngcontent-%COMP%]{position:static}.mat-form-field-subscript-wrapper.checkbox-error[_ngcontent-%COMP%]{padding:0!important;margin-top:16px}"] });
__decorate([
    Input()
], CheckboxComponent.prototype, "label", void 0);
__decorate([
    Input()
], CheckboxComponent.prototype, "formControl", void 0);
__decorate([
    Input()
], CheckboxComponent.prototype, "errorMessages", void 0);
__decorate([
    Input()
], CheckboxComponent.prototype, "disabled", null);
__decorate([
    Output()
], CheckboxComponent.prototype, "linkClicked", void 0);
__decorate([
    Output()
], CheckboxComponent.prototype, "valueChanged", void 0);

var RadioButtonComponent_1;
let RadioButtonComponent = RadioButtonComponent_1 = class RadioButtonComponent {
    constructor() {
        this.formControl = new FormControl();
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    writeValue(value) {
        if (value === this.formControl.value) {
            return;
        }
        this.formControl.setValue(value);
        this.onChangeCallback(value);
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
};
RadioButtonComponent.ɵfac = function RadioButtonComponent_Factory(t) { return new (t || RadioButtonComponent)(); };
RadioButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RadioButtonComponent, selectors: [["zip-radio-button"]], inputs: { formControl: "formControl", label: "label" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RadioButtonComponent_1),
                multi: true
            }
        ])], decls: 2, vars: 2, consts: [[3, "value"]], template: function RadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-radio-button", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("value", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, directives: [ɵngcc13.MatRadioButton], styles: [".mat-radio-label-content{padding-left:16px!important;font-size:15px;line-height:21px}  .mat-radio-outer-circle{width:21px!important;height:21px!important;border:1px solid #959196!important}  .mat-radio-button .mat-radio-ripple{height:45px!important;width:45px!important;left:calc(50% - 22px)!important;top:calc(50% - 22px)!important}  .mat-radio-inner-circle{height:21px!important;width:21px!important}"] });
__decorate([
    Input()
], RadioButtonComponent.prototype, "label", void 0);
__decorate([
    Input()
], RadioButtonComponent.prototype, "formControl", void 0);

let DisableControlDirective = class DisableControlDirective {
    constructor(ngControl) {
        this.ngControl = ngControl;
    }
    set zipDisableControl(condition) {
        const action = condition ? 'disable' : 'enable';
        if (this.ngControl.control !== undefined) {
            this.ngControl.control[action]();
        }
    }
};
DisableControlDirective.ɵfac = function DisableControlDirective_Factory(t) { return new (t || DisableControlDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.NgControl)); };
DisableControlDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DisableControlDirective, selectors: [["", "zipDisableControl", ""]], inputs: { zipDisableControl: "zipDisableControl" } });
DisableControlDirective.ctorParameters = () => [
    { type: NgControl }
];
__decorate([
    Input()
], DisableControlDirective.prototype, "zipDisableControl", null);

let ZipStyleguideDirectivesModule = class ZipStyleguideDirectivesModule {
};
ZipStyleguideDirectivesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ZipStyleguideDirectivesModule });
ZipStyleguideDirectivesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ZipStyleguideDirectivesModule_Factory(t) { return new (t || ZipStyleguideDirectivesModule)(); }, imports: [[]] });

var ToastType;
(function (ToastType) {
    ToastType["info"] = "info";
    ToastType["error"] = "error";
    ToastType["warning"] = "warning";
    ToastType["success"] = "success";
})(ToastType || (ToastType = {}));

let ToastComponent = class ToastComponent {
    constructor(data, toastRef) {
        this.data = data;
        this.toastRef = toastRef;
        this.type = ToastType.info;
        this.type = data.type;
        switch (data.type) {
            case ToastType.info:
                this.icon = 'toast-info';
                this.closeIcon = 'close-info';
                break;
            case ToastType.warning:
                this.icon = 'toast-warning';
                this.closeIcon = 'close-warning';
                break;
            case ToastType.error:
                this.icon = 'toast-error';
                this.closeIcon = 'close-error';
                break;
            case ToastType.success:
                this.icon = 'toast-success';
                this.closeIcon = 'close-success';
                break;
        }
    }
    close() {
        this.toastRef.dismiss();
    }
};
ToastComponent.ɵfac = function ToastComponent_Factory(t) { return new (t || ToastComponent)(ɵngcc0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA), ɵngcc0.ɵɵdirectiveInject(ɵngcc14.MatSnackBarRef)); };
ToastComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToastComponent, selectors: [["zip-toast"]], hostVars: 2, hostBindings: function ToastComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.type);
    } }, decls: 5, vars: 6, consts: [["class", "zip-icon", 4, "ngIf"], [1, "text", 3, "innerHtml"], [1, "zip-icon", 3, "click"], ["type", "fearless-icons", 1, "close-icon", 3, "src"], [1, "zip-icon"], ["type", "fearless-icons", 1, "featured-icon", 3, "src"]], template: function ToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ToastComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵlistener("click", function ToastComponent_Template_div_click_3_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelement(4, "zip-icon", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("word-break", ctx.data.wordBreak);
        ɵngcc0.ɵɵproperty("innerHtml", ctx.data.text, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.text);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.closeIcon);
    } }, directives: [ɵngcc1.NgIf, IconComponent], styles: ["[_nghost-%COMP%]{display:-webkit-box;display:flex;align-content:center;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;min-height:48px}.info[_nghost-%COMP%]{background-color:#d8e7fd;color:#0d5ed9}.info[_nghost-%COMP%]   .text[_ngcontent-%COMP%]     a{color:#0d5ed9;text-decoration:underline}.error[_nghost-%COMP%]{background-color:#feefec;color:#b00020}.error[_nghost-%COMP%]   .text[_ngcontent-%COMP%]     a{color:#b00020;text-decoration:underline}.success[_nghost-%COMP%]{background-color:#cff4db;color:#1f7a39}.success[_nghost-%COMP%]   .text[_ngcontent-%COMP%]     a{color:#1f7a39;text-decoration:underline}.warning[_nghost-%COMP%]{background-color:#feedd8;color:#995700}.warning[_nghost-%COMP%]   .text[_ngcontent-%COMP%]     a{color:#995700;text-decoration:underline}[_nghost-%COMP%]   .zip-icon[_ngcontent-%COMP%]{margin:auto 16px}[_nghost-%COMP%]   .text[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1 1 auto;margin:16px 0;font-family:\"Sharp Grotesk Book\",sans-serif;font-style:normal;font-weight:400;font-size:11px;line-height:18px;letter-spacing:.4px;overflow-wrap:break-word;word-break:break-word}[_nghost-%COMP%]   .featured-icon[_ngcontent-%COMP%]{width:20px}[_nghost-%COMP%]   .close-icon[_ngcontent-%COMP%]{cursor:pointer;width:16px}[_nghost-%COMP%]   img[_ngcontent-%COMP%]{display:-webkit-box;display:flex}  .mat-snack-bar-container{padding:0!important;margin:12px 16px!important;min-width:auto!important;background:0 0!important}@media only screen and (max-width:800px){  .cdk-global-overlay-wrapper{-webkit-box-align:end!important;align-items:flex-end!important}}"] });
ToastComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MAT_SNACK_BAR_DATA,] }] },
    { type: MatSnackBarRef }
];
__decorate([
    HostBinding('class')
], ToastComponent.prototype, "type", void 0);
ToastComponent = __decorate([ __param(0, Inject(MAT_SNACK_BAR_DATA))
], ToastComponent);

let TooltipComponent = class TooltipComponent {
};
TooltipComponent.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(); };
TooltipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["zip-tooltip"]], inputs: { message: "message" }, ngContentSelectors: _c1, decls: 2, vars: 1, consts: [[1, "dashed-underline", 3, "matTooltip"]], template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("matTooltip", ctx.message);
    } }, directives: [ɵngcc15.MatTooltip], styles: [""] });
__decorate([
    Input()
], TooltipComponent.prototype, "message", void 0);

const Toast = {
    Type: ToastType
};
let ToastService = class ToastService {
    constructor(snackBar) {
        this.snackBar = snackBar;
    }
    open({ text, type = ToastType.info, duration = 4000, wordBreak = 'normal' } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = new MatSnackBarConfig();
            config.data = { text, type, wordBreak };
            config.duration = duration;
            this.snackBar.openFromComponent(ToastComponent, config);
        });
    }
    close() {
        this.snackBar.dismiss();
    }
};
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(ɵngcc0.ɵɵinject(ɵngcc14.MatSnackBar)); };
ToastService.ctorParameters = () => [
    { type: MatSnackBar }
];
ToastService.ɵprov = ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(ɵɵinject(MatSnackBar)); }, token: ToastService, providedIn: "root" });

var TextAreaComponent_1;
let TextAreaComponent = TextAreaComponent_1 = class TextAreaComponent {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.formControl = new FormControl();
        this.type = 'text';
        this.rows = 4;
        this.maxLength = null;
        this.errorMessages = {};
        this.value = '';
        this.linkClicked = new EventEmitter();
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    triggerResize() {
        this.ngZone.onStable.pipe(take(1))
            .subscribe(() => this.autosize.resizeToFitContent(true));
    }
    linkClick() {
        this.linkClicked.emit(true);
    }
    get invalid() {
        return this.formControl.status === 'INVALID';
    }
    get error() {
        if (!this.formControl.errors) {
            return null;
        }
        const error = Object.keys(this.formControl.errors)
            .map(validationError => this.errorMessages[validationError])[0];
        return error || 'Invalid';
    }
    writeValue(value) {
        if (value === this.formControl.value) {
            return;
        }
        this.formControl.setValue(value);
        this.onChangeCallback(value);
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
};
TextAreaComponent.ɵfac = function TextAreaComponent_Factory(t) { return new (t || TextAreaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
TextAreaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TextAreaComponent, selectors: [["zip-textarea"]], viewQuery: function TextAreaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autosize = _t.first);
    } }, inputs: { formControl: "formControl", type: "type", rows: "rows", maxLength: "maxLength", errorMessages: "errorMessages", value: "value", label: "label", placeholder: "placeholder", hint: "hint" }, outputs: { linkClicked: "linkClicked" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextAreaComponent_1),
                multi: true
            }
        ])], decls: 8, vars: 8, consts: [["appearance", "outline", 1, "zip"], ["matInput", "", "cdkTextareaAutosize", "", "id", "element", 3, "formControl", "placeholder", "type", "cdkAutosizeMinRows", "maxlength"], ["autosize", "cdkTextareaAutosize"], [3, "innerHTML", "click", 4, "ngIf"], [3, "innerHTML", "click"]], template: function TextAreaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵelementStart(1, "mat-label");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "textarea", 1, 2);
        ɵngcc0.ɵɵelementStart(5, "mat-hint");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, TextAreaComponent_mat_error_7_Template, 2, 2, "mat-error", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.formControl)("placeholder", ctx.placeholder)("type", ctx.type)("cdkAutosizeMinRows", ctx.rows)("maxlength", ctx.maxLength);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.hint);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formControl.invalid);
    } }, directives: [ɵngcc6.MatFormField, ɵngcc6.MatLabel, ɵngcc7.MatInput, ɵngcc16.CdkTextareaAutosize, ɵngcc8.DefaultValueAccessor, ɵngcc8.NgControlStatus, ɵngcc8.FormControlDirective, ɵngcc8.MaxLengthValidator, ɵngcc6.MatHint, ɵngcc1.NgIf, ɵngcc6.MatError], styles: ["textarea[_ngcontent-%COMP%]{font-family:\"Sharp Grotesk Book\",sans-serif;font-size:14px;line-height:22px;letter-spacing:.4px}[_nghost-%COMP%]     .mat-form-field-appearance-outline .mat-form-field-outline{height:calc(100% - 6.5px)!important}"] });
TextAreaComponent.ctorParameters = () => [
    { type: NgZone }
];
__decorate([
    Input()
], TextAreaComponent.prototype, "label", void 0);
__decorate([
    Input()
], TextAreaComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], TextAreaComponent.prototype, "hint", void 0);
__decorate([
    Input()
], TextAreaComponent.prototype, "formControl", void 0);
__decorate([
    Input()
], TextAreaComponent.prototype, "type", void 0);
__decorate([
    Input()
], TextAreaComponent.prototype, "rows", void 0);
__decorate([
    Input()
], TextAreaComponent.prototype, "maxLength", void 0);
__decorate([
    Input()
], TextAreaComponent.prototype, "errorMessages", void 0);
__decorate([
    Input()
], TextAreaComponent.prototype, "value", void 0);
__decorate([
    ViewChild('autosize', { static: false })
], TextAreaComponent.prototype, "autosize", void 0);
__decorate([
    Output()
], TextAreaComponent.prototype, "linkClicked", void 0);

let ZipStyleguideCoreModule = class ZipStyleguideCoreModule {
};
ZipStyleguideCoreModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ZipStyleguideCoreModule });
ZipStyleguideCoreModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ZipStyleguideCoreModule_Factory(t) { return new (t || ZipStyleguideCoreModule)(); }, providers: [
        ToastService
    ], imports: [[
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            MatFormFieldModule,
            MatCheckboxModule,
            MatIconModule,
            MatInputModule,
            MatRadioModule,
            MatSelectModule,
            MatSnackBarModule,
            ZipStyleguideDirectivesModule,
            ZipStyleguideIconsModule,
            MatTooltipModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IconComponent, [{
        type: Component,
        args: [{
                selector: 'zip-icon',
                template: `<img *ngIf="useImg" src={{asset}} alt="icon"/>`,
                styles: ["@import url(https://zip.co/assets/zip/icons/style.css);:host{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}img{width:inherit;height:inherit}"]
            }]
    }], function () { return []; }, { icon: [{
            type: HostBinding,
            args: ['attr.class']
        }], type: [{
            type: Input
        }], class: [{
            type: Input
        }], src: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ZipStyleguideIconsModule, { declarations: function () { return [IconComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [IconComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ZipStyleguideIconsModule, [{
        type: NgModule,
        args: [{
                declarations: [IconComponent],
                imports: [CommonModule],
                entryComponents: [],
                exports: [IconComponent]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'zip-button',
                template: "<button\r\n    [type]=\"type\"\r\n    [ngClass]=\"[theme]\"\r\n    [disabled]=\"disabled !== false\">\r\n    <div\r\n        *ngIf=\"isLoading\"\r\n        class=\"loader\">\r\n        <span></span>\r\n        <span></span>\r\n        <span></span>\r\n    </div>\r\n    <div\r\n        class=\"content\"\r\n        [class.post-loading]=\"loadingFinished\"\r\n        *ngIf=\"!isLoading\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</button>\r\n",
                styles: ["button{font-family:\"Sharp Grotesk Medium\",sans-serif;height:50px;width:inherit;border-radius:8px;font-weight:500;font-size:14px;line-height:20px;letter-spacing:.5px;cursor:pointer}button .content{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}button.secondary:active,button.secondary:focus,button:active,button:focus{outline:0}button[disabled]{cursor:default;pointer-events:none;opacity:.4}button.tertiary{line-height:normal}button.tertiary:active,button.tertiary:focus{outline:0}button.icon{border-radius:50%;width:56px;height:56px}button.icon img{width:30px;height:30px}.loader{cursor:default;pointer-events:none}.loader span{width:6px;height:6px;margin:0 5px;border-radius:50%;display:inline-block;-webkit-animation-name:loading;animation-name:loading;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}.loader span:nth-child(2){-webkit-animation-delay:.4s;animation-delay:.4s}.loader span:nth-child(3){-webkit-animation-delay:.8s;animation-delay:.8s}@-webkit-keyframes loading{50%{-webkit-transform:scale(1.6);transform:scale(1.6)}}@keyframes loading{50%{-webkit-transform:scale(1.6);transform:scale(1.6)}}"]
            }]
    }], function () { return []; }, { theme: [{
            type: Input
        }], disabled: [{
            type: Input
        }], type: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WebModalMobileComponent, [{
        type: Component,
        args: [{
                selector: 'zip-web-modal-mobile',
                template: `
    <zip-button *ngIf="data.icon" class="web-modal-icon" theme="icon">
      <zip-icon
        *ngIf="data.icon"
        type="{{ data.iconType }}"
        src="{{ data.icon }}"
      ></zip-icon>
    </zip-button>
    <h3 mat-dialog-title class="web-modal-title">
      {{ data.title }}
    </h3>
    <mat-dialog-content
      class="web-modal-content"
      [innerHTML]="data.message"
    ></mat-dialog-content>
    <mat-dialog-actions class="web-modal-actions center">
      <zip-button
        *ngIf="data.actionLeft"
        theme="text"
        (click)="close()"
        class="left"
      >
        {{ data.actionLeft }}
      </zip-button>
      <zip-button *ngIf="data.actionRight" (click)="confirm()" class="right">
        {{ data.actionRight }}
      </zip-button>
    </mat-dialog-actions>
  `,
                styles: [":host{background-color:#fff;display:block;width:100%}:host *{color:#1a0826}:host .web-modal-title{font-family:\"Cooper Lt BT\",sans-serif;font-weight:400;font-size:28px;line-height:34px;margin-bottom:16px!important;margin-top:0!important}:host .web-modal-content{margin:0 0 16px;padding:0;width:inherit;font-family:\"Sharp Grotesk Book\",sans-serif;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.4px}:host .web-modal-actions{display:-webkit-box;display:flex;flex-wrap:wrap;-webkit-box-align:center;align-items:center;-webkit-box-pack:justify;justify-content:space-between;padding:0;margin:32px 0 0}:host .web-modal-actions.center{-webkit-box-orient:vertical;-webkit-box-direction:reverse;flex-direction:column-reverse}:host .web-modal-actions.center .left{width:100%}:host .web-modal-actions.center .right{width:100%}:host .left{margin-right:auto}:host .right{margin-left:auto}:host .web-modal-icon{display:-webkit-box;display:flex;margin-bottom:16px}:host .web-modal-icon ::ng-deep button{cursor:initial}:host .web-modal-icon ::ng-deep button:hover{background-color:currentColor}::ng-deep .mat-dialog-content p:not(:last-child){margin:0 0 16px}::ng-deep .mat-dialog-content p:last-child{margin:0}::ng-deep zip-button.right button{padding:15px 32px}::ng-deep .web-modal-container{margin:32px;-ms-grid-row-align:center;align-self:center}::ng-deep .web-modal-container .mat-dialog-container{padding:32px;border-radius:8px;box-shadow:0 0 36px rgba(0,0,0,.08)}::ng-deep .web-modal-mobile-container{padding:32px 24px;border-radius:8px;box-shadow:0 0 36px rgba(0,0,0,.08)}::ng-deep .web-modal-backdrop{background-color:rgba(255,255,255,.2);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}"]
            }]
    }], function () { return [{ type: ɵngcc2.MatBottomSheetRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_BOTTOM_SHEET_DATA]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WebModalComponent, [{
        type: Component,
        args: [{
                selector: 'zip-web-modal',
                template: `
    <zip-button *ngIf="data.icon" class="web-modal-icon" theme="icon">
      <zip-icon
        *ngIf="data.icon"
        type="{{ data.iconType }}"
        src="{{ data.icon }}"
      ></zip-icon>
    </zip-button>
    <h3 mat-dialog-title class="web-modal-title">
      {{ data.title }}
    </h3>
    <mat-dialog-content
      class="web-modal-content"
      [innerHTML]="data.message"
    ></mat-dialog-content>
    <mat-dialog-actions
      class="web-modal-actions"
      [ngClass]="{ center: centered }"
    >
      <zip-button
        *ngIf="data.actionLeft"
        theme="text"
        (click)="close()"
        class="left"
      >
        {{ data.actionLeft }}
      </zip-button>
      <zip-button *ngIf="data.actionRight" (click)="confirm()" class="right">
        {{ data.actionRight }}
      </zip-button>
    </mat-dialog-actions>
  `,
                styles: [":host{background-color:#fff;display:block;width:100%}:host *{color:#1a0826}:host .web-modal-title{font-family:\"Cooper Lt BT\",sans-serif;font-weight:400;font-size:28px;line-height:34px;margin-bottom:16px!important;margin-top:0!important}:host .web-modal-content{margin:0 0 16px;padding:0;width:inherit;font-family:\"Sharp Grotesk Book\",sans-serif;font-weight:400;font-size:14px;line-height:20px;letter-spacing:.4px}:host .web-modal-actions{display:-webkit-box;display:flex;flex-wrap:wrap;-webkit-box-align:center;align-items:center;-webkit-box-pack:justify;justify-content:space-between;padding:0;margin:32px 0 0}:host .web-modal-actions.center{-webkit-box-orient:vertical;-webkit-box-direction:reverse;flex-direction:column-reverse}:host .web-modal-actions.center .left{width:100%}:host .web-modal-actions.center .right{width:100%}:host .left{margin-right:auto}:host .right{margin-left:auto}:host .web-modal-icon{display:-webkit-box;display:flex;margin-bottom:16px}:host .web-modal-icon ::ng-deep button{cursor:initial}:host .web-modal-icon ::ng-deep button:hover{background-color:currentColor}::ng-deep .mat-dialog-content p:not(:last-child){margin:0 0 16px}::ng-deep .mat-dialog-content p:last-child{margin:0}::ng-deep zip-button.right button{padding:15px 32px}::ng-deep .web-modal-container{margin:32px;-ms-grid-row-align:center;align-self:center}::ng-deep .web-modal-container .mat-dialog-container{padding:32px;border-radius:8px;box-shadow:0 0 36px rgba(0,0,0,.08)}::ng-deep .web-modal-mobile-container{padding:32px 24px;border-radius:8px;box-shadow:0 0 36px rgba(0,0,0,.08)}::ng-deep .web-modal-backdrop{background-color:rgba(255,255,255,.2);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}"]
            }]
    }], function () { return [{ type: ɵngcc3.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WebModalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.BreakpointObserver }, { type: ɵngcc3.MatDialog }, { type: ɵngcc2.MatBottomSheet }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmDialogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: WebModalService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoaderComponent, [{
        type: Component,
        args: [{
                selector: 'zip-loader',
                template: `
        <ng-lottie
            [options]="options"
            [width]="width"
            [height]="height">
        </ng-lottie>
    `
            }]
    }], function () { return []; }, { width: [{
            type: Input
        }], type: [{
            type: Input
        }], height: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProgressBarComponent, [{
        type: Component,
        args: [{
                selector: 'zip-progress-bar',
                template: "<img [src]=\"imageUrl\" *ngIf=\"imageUrl\">\r\n<div class=\"bar\">\r\n    <div class=\"step\" *ngFor=\"let step of steps; let i = index\" [class.active]=\"i <= currentStep\"></div>\r\n</div>\r\n<span class=\"message\" [innerHtml]=\"message\" *ngIf=\"message\">{{message}}</span>\r\n",
                styles: ["img{height:28px}:host{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:justify;justify-content:space-between}.bar{margin:0 8px 0 24px;padding:12px 0;display:-webkit-box;display:flex;width:100%;-webkit-box-align:center;align-items:center}.step{width:calc((100% - (var(--totalStep) * 2px))/ var(--totalStep));height:4px;margin-right:2px;background:#e7e4e4;-webkit-transform:skewX(10deg);transform:skewX(10deg)}.step:first-of-type::before,.step:last-of-type::before{position:absolute;content:\"\";height:inherit;width:10%;background-color:inherit;-webkit-transform:skewX(-10deg);transform:skewX(-10deg);-webkit-transform-origin:bottom left;transform-origin:bottom left}.step:first-of-type::before{left:-1px}.step:last-of-type{margin-right:0}.step:last-of-type::before{right:0}.message{color:#959196;font-size:11px;line-height:18px;white-space:nowrap;min-width:4%;text-align:right}"]
            }]
    }], null, { currentStep: [{
            type: Input
        }], totalStep: [{
            type: Input
        }], imageUrl: [{
            type: Input
        }], message: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoadingSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'zip-loading-spinner',
                template: "<div class=\"zip-spinner\">\r\n    <div id=\"spin1\" class=\"spin\"></div>\r\n    <div id=\"spin2\" class=\"spin\"></div>\r\n    <div id=\"spin3\" class=\"spin\"></div>\r\n    <div id=\"spin4\" class=\"spin\"></div>\r\n</div>\r\n",
                styles: ["*{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-Mac-osx-font-smoothing:grayscale;box-sizing:border-box;list-style-type:none;text-decoration:none;color:inherit;font-family:Rubik,sans-serif}:active,:focus{outline:0}.align-center{text-align:center}.align-left{text-align:left}.align-right{text-align:right}a,h1,h2,h3,h4,h5,h6,p{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-weight:600}h1{font-size:28px;line-height:32px;margin-bottom:28px}@media (min-width:769px){h1{font-size:30px;line-height:34px}}h2{font-size:26px;line-height:30px;margin-bottom:24px}@media (min-width:769px){h2{font-size:28px;line-height:32px}}h3{font-size:24px;line-height:28px;margin-bottom:20px}@media (min-width:769px){h3{font-size:26px;line-height:30px}}h4{font-size:22px;line-height:26px;margin-bottom:16px}@media (min-width:769px){h4{font-size:24px;line-height:28px}}h5{font-size:20px;line-height:22px;margin-bottom:12px}@media (min-width:769px){h5{font-size:22px;line-height:26px}}h6{font-size:18px;line-height:20px;margin-bottom:8px}@media (min-width:769px){h6{font-size:20px;line-height:24px}}a{color:#3e85f4;text-decoration:underline}a,label,p{font-size:14px;line-height:18px;font-weight:400;margin-bottom:4px}@media (min-width:769px){a,label,p{font-size:16px;line-height:22px;margin-bottom:8px}}label{display:block}em{font-size:inherit;font-weight:600}code{display:block;font-size:14px;font-family:Inconsolata,monospace;padding:10px;background:#eee;border-radius:4px;white-space:pre-wrap}.margin-bottom-level-0{margin-bottom:0!important}.margin-bottom-level-1{margin-bottom:4px!important}.margin-bottom-level-2{margin-bottom:8px!important}.margin-bottom-level-3{margin-bottom:12px!important}.margin-bottom-level-4{margin-bottom:16px!important}.margin-bottom-level-5{margin-bottom:20px!important}.margin-bottom-level-6{margin-bottom:24px!important}.margin-bottom-level-7{margin-bottom:28px!important}.margin-bottom-level-8{margin-bottom:32px!important}.margin-bottom-level-9{margin-bottom:36px!important}.margin-bottom-level-10{margin-bottom:40px!important}.zip-spinner{width:70px;height:70px;margin:24px auto;position:relative}.spin{width:70px;height:70px;position:absolute}.spin:before{content:\"\";height:28px;width:28px;border-radius:50%;position:absolute}#spin1:before{background-color:#f8991c}#spin2:before{background-color:#1b1e63}#spin3:before{background-color:#00aeb8}#spin4:before{background-color:#f15c3e}#spin1{-webkit-transform:rotate(360deg);transform:rotate(360deg);-webkit-animation:1s linear infinite timer1;animation:1s linear infinite timer1}#spin2{-webkit-transform:rotate(270deg);transform:rotate(270deg);-webkit-animation:1s linear -.25s infinite timer1;animation:1s linear -.25s infinite timer1}#spin3{-webkit-transform:rotate(180deg);transform:rotate(180deg);-webkit-animation:1s linear -.5s infinite timer1;animation:1s linear -.5s infinite timer1}#spin4{-webkit-transform:rotate(90deg);transform:rotate(90deg);-webkit-animation:1s linear -.75s infinite timer1;animation:1s linear -.75s infinite timer1}@-webkit-keyframes timer1{0%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}25%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}75%{-webkit-transform:rotate(90deg);transform:rotate(90deg)}100%{-webkit-transform:rotate(0);transform:rotate(0)}}@keyframes timer1{0%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}25%{-webkit-transform:rotate(270deg);transform:rotate(270deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}75%{-webkit-transform:rotate(90deg);transform:rotate(90deg)}100%{-webkit-transform:rotate(0);transform:rotate(0)}}"]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TableComponent, [{
        type: Component,
        args: [{
                selector: 'zip-table',
                template: /* html */ `
        <ng-content></ng-content>
    `,
                styles: [":host{display:block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host ::ng-deep{border-bottom:1px solid #e7e4e4}:host ::ng-deep>th,:host ::ng-deep>tr{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-flow:row wrap;-webkit-box-pack:justify;justify-content:space-between}:host ::ng-deep>th>[width=\"1\"],:host ::ng-deep>tr>[width=\"1\"]{width:calc(100% / 12 * 1)}:host ::ng-deep>th>[width=\"2\"],:host ::ng-deep>tr>[width=\"2\"]{width:calc(100% / 12 * 2)}:host ::ng-deep>th>[width=\"3\"],:host ::ng-deep>tr>[width=\"3\"]{width:calc(100% / 12 * 3)}:host ::ng-deep>th>[width=\"4\"],:host ::ng-deep>tr>[width=\"4\"]{width:calc(100% / 12 * 4)}:host ::ng-deep>th>[width=\"5\"],:host ::ng-deep>tr>[width=\"5\"]{width:calc(100% / 12 * 5)}:host ::ng-deep>th>[width=\"6\"],:host ::ng-deep>tr>[width=\"6\"]{width:calc(100% / 12 * 6)}:host ::ng-deep>th>[width=\"7\"],:host ::ng-deep>tr>[width=\"7\"]{width:calc(100% / 12 * 7)}:host ::ng-deep>th>[width=\"8\"],:host ::ng-deep>tr>[width=\"8\"]{width:calc(100% / 12 * 8)}:host ::ng-deep>th>[width=\"9\"],:host ::ng-deep>tr>[width=\"9\"]{width:calc(100% / 12 * 9)}:host ::ng-deep>th>[width=\"10\"],:host ::ng-deep>tr>[width=\"10\"]{width:calc(100% / 12 * 10)}:host ::ng-deep>th>[width=\"11\"],:host ::ng-deep>tr>[width=\"11\"]{width:calc(100% / 12 * 11)}:host ::ng-deep>th>[width=\"12\"],:host ::ng-deep>tr>[width=\"12\"]{width:calc(100% / 12 * 12)}:host ::ng-deep>th{border-bottom:1px solid #e7e4e4}:host ::ng-deep>th>*{font-size:14px}:host ::ng-deep>th>*,:host ::ng-deep>tr>*{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;min-height:44px;padding:10px 0;box-sizing:border-box;font-size:15px;font-weight:400}:host ::ng-deep>th>strong,:host ::ng-deep>tr>strong{color:#1a0826;font-weight:400}"]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WebInputComponent, [{
        type: Component,
        args: [{
                selector: 'zip-web-input',
                template: /* html */ `
        <p class="label">{{ label }}</p>
        <mat-form-field class="zip" appearance="outline">
            <input matInput [placeholder]=placeholder [formControl]="formControl" [type]="type" [value]="value"
            [matAutocomplete]="matAutocomplete" [matAutocompleteDisabled]= "matAutocomplete === null">
            <mat-hint innerHTML="{{hint}}" (click)="hintClick()">{{ hint }}</mat-hint>
            <mat-error *ngIf="formControl.invalid" innerHTML="{{error}}" (click)="errorClick()">{{error}}</mat-error>
            <span class="prefix" matPrefix *ngIf="prefix">{{ prefix }}</span>
            <span
                matSuffix
                *ngIf="
                formControl.touched &&
                formControl.invalid
                ">
                <zip-icon src="alert"></zip-icon>
            </span>
        </mat-form-field>
    `,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => WebInputComponent_1),
                        multi: true
                    }
                ],
                styles: [".label{font-size:14px;line-height:1.46;margin-top:0;margin-bottom:4px}input,span{font-family:\"Sharp Grotesk Book\",sans-serif;font-size:14px;line-height:20px;letter-spacing:.4px}.mat-form-field{width:100%}:host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix{padding:14px 0}:host ::ng-deep .mat-form-field-infix{border-top:none}:host ::ng-deep .mat-form-field-prefix{top:-.15em!important}:host ::ng-deep .mat-form-field-suffix{top:.65em!important}:host ::ng-deep .mat-form-field-flex,:host ::ng-deep .mat-form-field-outline,:host ::ng-deep .mat-form-field-outline-thick,:host ::ng-deep .mat-form-field-wrapper{height:45px!important}"]
            }]
    }], function () { return []; }, { formControl: [{
            type: Input
        }], matAutocomplete: [{
            type: Input
        }], type: [{
            type: Input
        }], errorMessages: [{
            type: Input
        }], value: [{
            type: Input
        }], hintClicked: [{
            type: Output
        }], errorClicked: [{
            type: Output
        }], label: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], icon: [{
            type: Input
        }], hint: [{
            type: Input
        }], prefix: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ZipStyleguideWebModule, { declarations: function () { return [LoadingSpinnerComponent,
        ButtonComponent,
        WebInputComponent,
        TableComponent,
        WebModalComponent,
        ProgressBarComponent,
        LoaderComponent,
        WebModalMobileComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatDialogModule,
        MatBottomSheetModule,
        MatInputModule,
        FormsModule,
        ZipStyleguideIconsModule, ɵngcc5.LottieModule]; }, exports: function () { return [LoadingSpinnerComponent,
        ButtonComponent,
        WebInputComponent,
        TableComponent,
        ProgressBarComponent,
        LoaderComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ZipStyleguideWebModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LoadingSpinnerComponent,
                    ButtonComponent,
                    WebInputComponent,
                    TableComponent,
                    WebModalComponent,
                    ProgressBarComponent,
                    LoaderComponent,
                    WebModalMobileComponent
                ],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    MatAutocompleteModule,
                    MatDialogModule,
                    MatBottomSheetModule,
                    MatInputModule,
                    FormsModule,
                    ZipStyleguideIconsModule,
                    LottieModule.forRoot({ player: playerFactory }),
                ],
                providers: [
                    ConfirmDialogService,
                    WebModalService
                ],
                entryComponents: [
                    WebModalComponent,
                    WebModalMobileComponent
                ],
                exports: [
                    LoadingSpinnerComponent,
                    ButtonComponent,
                    WebInputComponent,
                    TableComponent,
                    ProgressBarComponent,
                    LoaderComponent,
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProgressBarService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['enumObject']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                selector: 'zip-input',
                template: /* html */ `
        <mat-form-field class="zip" appearance="outline">
            <mat-label>{{ label }}</mat-label>
            <input matInput [placeholder]=placeholder [formControl]="formControl" [type]="type" [value]="value">
            <mat-hint>{{ hint }}</mat-hint>
            <mat-error *ngIf="formControl.invalid" innerHTML="{{error}}" (click)="linkClick()">{{error}}</mat-error>
            <span matSuffix *ngIf="icon && !(formControl.touched && formControl.invalid)">
                <zip-icon [src]=icon></zip-icon>
            </span>
            <span matSuffix *ngIf=" formControl.touched && formControl.invalid">
                <zip-icon type="fearless-icons" src="toast-error"></zip-icon>
            </span>
        </mat-form-field>
    `,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => InputComponent_1),
                        multi: true
                    }
                ],
                styles: ["::ng-deep a{cursor:pointer}"]
            }]
    }], function () { return []; }, { formControl: [{
            type: Input
        }], type: [{
            type: Input
        }], errorMessages: [{
            type: Input
        }], value: [{
            type: Input
        }], linkClicked: [{
            type: Output
        }], label: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], icon: [{
            type: Input
        }], hint: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{
                selector: 'zip-select',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SelectComponent_1),
                        multi: true
                    }
                ],
                template: /* html */ `
    <mat-form-field appearance="outline">
        <mat-label>{{ label }}</mat-label>
        <mat-select [placeholder]=placeholder disableOptionCentering [formControl]=formControl
            (selectionChange)="select($event)" [compareWith]="objectComparisonFunction">
            <mat-option *ngFor="let item of items" [value]="item">
                {{ key ? item[key] : item }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="formControl.invalid" innerHTML="{{error}}" (click)="linkClick()">{{error}}</mat-error>
    </mat-form-field>
    `,
                styles: [":host ::ng-deep .mat-select-panel{margin-top:35px;padding-top:8px!important;width:100%!important}:host ::ng-deep .mat-form-field.mat-focused.mat-primary .mat-select-arrow{-webkit-transform:rotate(225deg)!important;transform:rotate(225deg)!important;margin-top:7px!important}:host ::ng-deep .mat-form-field .mat-select.mat-select-invalid .mat-select-arrow{color:#b00020!important}:host ::ng-deep .mat-form-field .mat-select.mat-select-disabled .mat-select-arrow{color:#e0dee0!important}.mat-option.mat-selected{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;flex-direction:row-reverse}.mat-option.mat-selected::before{width:1.5rem;height:1.5rem;display:inline-block;content:\"\";-webkit-mask:url(https://zip.co/assets/fearless/icons/check.svg);mask:url(https://zip.co/assets/fearless/icons/check.svg);-webkit-mask-size:cover;mask-size:cover}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { items: [{
            type: Input
        }], key: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], errorMessages: [{
            type: Input
        }], formControl: [{
            type: Input
        }], selectChange: [{
            type: Output
        }], linkClicked: [{
            type: Output
        }], disabled: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'zip-checkbox',
                template: /* html */ `
        <mat-checkbox [formControl]="formControl" (change)="onValueChange($event)">
            <span [innerHTML]="label"></span>
        </mat-checkbox>
        <div class="mat-form-field-subscript-wrapper checkbox-error" ng-reflect-ng-switch="error">
            <mat-error *ngIf="formControl.invalid && formControl.touched" innerHTML="{{error}}"
                (click)="linkClick()">{{error}}</mat-error>
        </div>
    `,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxComponent_1),
                        multi: true
                    }
                ],
                styles: [":host ::ng-deep .mat-checkbox-inner-container{width:21px!important;height:21px!important;margin-right:16px!important;margin-top:0!important}:host ::ng-deep .mat-checkbox-frame{border:1px solid #959196;border-radius:2px!important;width:21px;height:21px;border-width:1px!important}:host ::ng-deep .mat-checkbox-checked.mat-accent .mat-checkbox-background{width:21px;height:21px}:host ::ng-deep .mat-checkbox .mat-checkbox-ripple{height:45px!important;width:45px!important;left:calc(50% - 23px)!important;top:calc(50% - 23px)!important}:host ::ng-deep .mat-checkbox-layout .mat-checkbox-label{font-size:14px;line-height:20px;letter-spacing:.4px;white-space:normal!important;vertical-align:baseline}:host ::ng-deep .mat-checkbox-layout{vertical-align:baseline!important}:host.ng-invalid.ng-touched ::ng-deep .mat-checkbox-frame{border:1px solid #b00020!important;box-sizing:border-box;border-radius:2px!important}.mat-error{position:static}.mat-form-field-subscript-wrapper.checkbox-error{padding:0!important;margin-top:16px}"]
            }]
    }], function () { return []; }, { formControl: [{
            type: Input
        }], errorMessages: [{
            type: Input
        }], linkClicked: [{
            type: Output
        }], valueChanged: [{
            type: Output
        }], disabled: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RadioButtonComponent, [{
        type: Component,
        args: [{
                selector: 'zip-radio-button',
                template: /* html */ `
    <mat-radio-button [value]=label>{{ label }}</mat-radio-button>
  `,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RadioButtonComponent_1),
                        multi: true
                    }
                ],
                styles: ["::ng-deep .mat-radio-label-content{padding-left:16px!important;font-size:15px;line-height:21px}::ng-deep .mat-radio-outer-circle{width:21px!important;height:21px!important;border:1px solid #959196!important}::ng-deep .mat-radio-button .mat-radio-ripple{height:45px!important;width:45px!important;left:calc(50% - 22px)!important;top:calc(50% - 22px)!important}::ng-deep .mat-radio-inner-circle{height:21px!important;width:21px!important}"]
            }]
    }], function () { return []; }, { formControl: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DisableControlDirective, [{
        type: Directive,
        args: [{
                selector: '[zipDisableControl]'
            }]
    }], function () { return [{ type: ɵngcc8.NgControl }]; }, { zipDisableControl: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ZipStyleguideDirectivesModule, { declarations: [DisableControlDirective], exports: [DisableControlDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ZipStyleguideDirectivesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DisableControlDirective,
                ],
                imports: [],
                exports: [
                    DisableControlDirective,
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastComponent, [{
        type: Component,
        args: [{
                selector: 'zip-toast',
                template: /* html */ `
        <div
            *ngIf="icon"
            class="zip-icon">
            <zip-icon class="featured-icon" type="fearless-icons" src={{icon}}></zip-icon>
        </div>
        <span class="text" [innerHtml]="data.text" [style.word-break]="data.wordBreak">{{data.text}}</span>
        <div
            (click)="close()"
            class="zip-icon">
            <zip-icon class="close-icon" type="fearless-icons" src={{closeIcon}}></zip-icon>
        </div>
    `,
                styles: [":host{display:-webkit-box;display:flex;align-content:center;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;min-height:48px}:host.info{background-color:#d8e7fd;color:#0d5ed9}:host.info .text ::ng-deep a{color:#0d5ed9;text-decoration:underline}:host.error{background-color:#feefec;color:#b00020}:host.error .text ::ng-deep a{color:#b00020;text-decoration:underline}:host.success{background-color:#cff4db;color:#1f7a39}:host.success .text ::ng-deep a{color:#1f7a39;text-decoration:underline}:host.warning{background-color:#feedd8;color:#995700}:host.warning .text ::ng-deep a{color:#995700;text-decoration:underline}:host .zip-icon{margin:auto 16px}:host .text{-webkit-box-flex:1;flex:1 1 auto;margin:16px 0;font-family:\"Sharp Grotesk Book\",sans-serif;font-style:normal;font-weight:400;font-size:11px;line-height:18px;letter-spacing:.4px;overflow-wrap:break-word;word-break:break-word}:host .featured-icon{width:20px}:host .close-icon{cursor:pointer;width:16px}:host img{display:-webkit-box;display:flex}::ng-deep .mat-snack-bar-container{padding:0!important;margin:12px 16px!important;min-width:auto!important;background:0 0!important}@media only screen and (max-width:800px){::ng-deep .cdk-global-overlay-wrapper{-webkit-box-align:end!important;align-items:flex-end!important}}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_SNACK_BAR_DATA]
            }] }, { type: ɵngcc14.MatSnackBarRef }]; }, { type: [{
            type: HostBinding,
            args: ['class']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{
                selector: 'zip-tooltip',
                template: /* html */ `
    <span class="dashed-underline" [matTooltip]="message">
      <ng-content></ng-content>
    </span>
  `,
                styles: [""]
            }]
    }], null, { message: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc14.MatSnackBar }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextAreaComponent, [{
        type: Component,
        args: [{
                selector: 'zip-textarea',
                template: /* html */ `
        <mat-form-field class="zip" appearance="outline">
            <mat-label>{{ label }}</mat-label>
            <textarea matInput cdkTextareaAutosize id="element" [formControl]="formControl" [placeholder]="placeholder" [type]="type"
                #autosize="cdkTextareaAutosize" [cdkAutosizeMinRows]="rows" [maxlength]="maxLength"></textarea>
            <mat-hint>{{ hint }}</mat-hint>
            <mat-error *ngIf="formControl.invalid" innerHTML="{{error}}" (click)="linkClick()">{{error}}</mat-error>
        </mat-form-field>
    `,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TextAreaComponent_1),
                        multi: true
                    }
                ],
                styles: ["textarea{font-family:\"Sharp Grotesk Book\",sans-serif;font-size:14px;line-height:22px;letter-spacing:.4px}:host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline{height:calc(100% - 6.5px)!important}"]
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { formControl: [{
            type: Input
        }], type: [{
            type: Input
        }], rows: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], errorMessages: [{
            type: Input
        }], value: [{
            type: Input
        }], linkClicked: [{
            type: Output
        }], label: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], hint: [{
            type: Input
        }], autosize: [{
            type: ViewChild,
            args: ['autosize', { static: false }]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ZipStyleguideCoreModule, { declarations: function () { return [InputComponent,
        SelectComponent,
        CheckboxComponent,
        RadioButtonComponent,
        ToastComponent,
        TextAreaComponent,
        TooltipComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatSnackBarModule,
        ZipStyleguideDirectivesModule,
        ZipStyleguideIconsModule,
        MatTooltipModule]; }, exports: function () { return [InputComponent,
        SelectComponent,
        CheckboxComponent,
        RadioButtonComponent,
        ToastComponent,
        TextAreaComponent,
        TooltipComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ZipStyleguideCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    InputComponent,
                    SelectComponent,
                    CheckboxComponent,
                    RadioButtonComponent,
                    ToastComponent,
                    TextAreaComponent,
                    TooltipComponent,
                ],
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    FormsModule,
                    MatFormFieldModule,
                    MatCheckboxModule,
                    MatIconModule,
                    MatInputModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatSnackBarModule,
                    ZipStyleguideDirectivesModule,
                    ZipStyleguideIconsModule,
                    MatTooltipModule,
                ],
                providers: [
                    ToastService
                ],
                entryComponents: [
                    ToastComponent
                ],
                exports: [
                    InputComponent,
                    SelectComponent,
                    CheckboxComponent,
                    RadioButtonComponent,
                    ToastComponent,
                    TextAreaComponent,
                    TooltipComponent,
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of zip-styleguide
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, CheckboxComponent, ConfirmDialogService, DisableControlDirective, IconComponent, InputComponent, LoaderComponent, LoadingSpinnerComponent, ProgressBarComponent, ProgressBarService, RadioButtonComponent, SelectComponent, TableComponent, TextAreaComponent, Toast, ToastComponent, ToastService, TooltipComponent, WebInputComponent, WebModalService, ZipStyleguideCoreModule, ZipStyleguideDirectivesModule, ZipStyleguideIconsModule, ZipStyleguideWebModule, playerFactory, WebModalComponent as ɵb, WebModalMobileComponent as ɵc, ToastType as ɵd };

//# sourceMappingURL=zip-ng-styleguide.js.map